
(function ($) {
  "use strict";
  $(document).ready(function(){
    
    

      // cart-plus-minus
    $(".cart-plus-minus").prepend('<div class="dec qtybutton">-</div>');
     $(".cart-plus-minus").append('<div class="inc qtybutton">+</div>');
     $(".qtybutton").on("click", function() {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
         // Don't allow decrementing below zero
        if (oldValue > 0) {
       var newVal = parseFloat(oldValue) - 1;
       } else {
       newVal = 0;
        }
        }
      $button.parent().find("input").val(newVal);
     });         
    
    
                  // mega_menu_slider    	
                    $(".relative_slider").owlCarousel({
                    autoplay:false,
                    autoplayTimeout:5000,
                    loop:true,
                    dots:false,
                      
                    nav:true,
                      navText:['<img src="//www.diamentowamozaika.com/cdn/shop/t/2/assets/prev.png?v=122657281401323794241647774409">','<img src="//www.diamentowamozaika.com/cdn/shop/t/2/assets/next.png?v=142549034947157455211647774406">'],
                    responsive:{
                        0:{
                            items:1
                        },
                        720:{
                            items:2,
                               margin: 30
                        },
                        960:{
                            items:3,
                               margin: 30
                        },
                        1200:{
                            items:4,
                               margin: 30
                        }
                    }            

                   });   
    
    
    
                 // mega_menu_slider    	
                    $(".home_slider").owlCarousel({
                    autoplay:true,
                    autoplayTimeout:5000,
                    loop:true,
                    dots:false,
                      
                    nav:true,
                      navText:['<img src="//www.diamentowamozaika.com/cdn/shop/t/2/assets/prev.png?v=122657281401323794241647774409">','<img src="//www.diamentowamozaika.com/cdn/shop/t/2/assets/next.png?v=142549034947157455211647774406">'],
                    responsive:{
                        0:{
                            items:1
                        },
                        720:{
                            items:2,
                               margin: 40
                        },
                        960:{
                            items:3,
                               margin: 70
                        },
                        1200:{
                            items:3,
                               margin: 100
                        }
                    }            

                   });  


//     $('.stap_info').matchHeight();




  }); 
})(jQuery); 